/**
 * The OGraf playAction target-step rule (Specification, playAction()):
 * - goto defined and >= 0 → target = goto;
 * - otherwise target = current + delta (delta defaults to 1), with current = -1 in the start state;
 * - target >= stepCount → transition to the end (returned as undefined).
 * stepCount -1 means dynamic/unknown: never ends by playAction. A negative target (e.g. delta -2 from step 0) is
 * not defined by the spec; we clamp it to step 0.
 */
export function targetStep(current: number | undefined, stepCount: number, goto?: number, delta?: number): number | undefined {
  let target: number;
  if (goto !== undefined && goto !== null && Number.isFinite(goto) && goto >= 0) target = Math.floor(goto);
  else {
    const d = delta === undefined || delta === null || !Number.isFinite(delta) ? 1 : Math.trunc(delta);
    target = (current ?? -1) + d;
  }
  if (stepCount >= 0 && target >= stepCount) return undefined;
  return Math.max(0, target);
}
